<template>
  <emd-modal
    :open="true"
    has-header
    has-footer
    @close="() => $emit('onCancel')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section">
        {{ $t('title') }}
      </h2>
    </template>
    <template v-slot:content>
      <emd-alert
        v-if="isLastTerminal"
        variant="warning"
        :title="$t('alertTitle')"
        noClose
      ></emd-alert>
      <p
        data-testid="isLastTerminalAlert"
        class="eu-mt_2 eu-mb_2 _paragraph"
      >
        {{ $t('content') }}
      </p>

      <jade-checkbox
        v-if="isLastTerminal"
        id="last-terminal-checkbox"
        :value.sync="isCheck"
        :label="$t('confirmCheckbox')"
      />
    </template>
    <template v-slot:footer>
      <div class="eu-flex eu-justify_end eu-width_100">
        <emd-button
          data-testid="button-success-reset-secret-key"
          type="text"
          color="success"
          @click="$emit('onCancel')"
          :text="$t('cancelButton')"
        />
        <emd-button
          data-testid="button-success-reset-secret-key"
          color="success"
          @click="$emit('onSubmit')"
          :text="$t('submitButton')"
        />
      </div>
    </template>
  </emd-modal>
</template>

<style scoped>
._paragraph {
  font-size: 16px;
  padding-right: 22px;
  line-height: 24px;
}
</style>

<i18n>
    {
      "pt-BR": {
        "title": "Desinstalação de Maquininha",
        "content": "Você tem certeza que deseja solicitar a desinstalação de sua maquininha?",
        "cancelButton": "Cancelar",
        "submitButton": "Desinstalar maquininha",
        "alertTitle": "Atenção! Está é sua única maquininha instalada.",
        "confirmCheckbox": "Eu tenho certeza que desejo desinstalar minha única maquininha"
      },
      "en-US": {
        "title": "Uninstall Terminal",
        "content": "Are you sure you want to request to uninstall your terminal?",
        "cancelButton": "Cancel",
        "submitButton": "Uninstall terminal",
        "alertTitle": "Attention! This is your only installed terminal.",
        "confirmCheckbox": "I'm sure I want to uninstall my only terminal"
      }
    }
</i18n>
<script>
import { EmdModal, EmdButton, EmdAlert } from 'emerald-vue/src/components'
import { JadeCheckbox } from '@jade'

export default {
  name: 'ModalUninstallTerminal',
  components: {
    EmdModal,
    EmdButton,
    EmdAlert,
    JadeCheckbox
  },
  data () {
    return {
      isCheck: false
    }
  },
  props: {
    isLastTerminal: {
      type: Boolean
    }
  }
}
</script>
